import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { BaseService } from './common/base.service';
import { TokenService } from './common/token.service';
import { CryptoJsService } from './crypto-js.service';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReportsService extends BaseService {

  protected http: HttpClient;
   user_name:any 
   userId:any;
   isVendor:any;
   officeCode:any;
  constructor(http: HttpClient, tokenService: TokenService,private cryptoJs: CryptoJsService) {
    super(tokenService);
    this.http = http;
  }
  parameter_api(){
    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJs.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const tokenInfo = loginDetails.get('tokenInfo') ? loginDetails.get('tokenInfo') : null;
    const officeCode = tokenInfo['officeCode'] ? tokenInfo['officeCode'] : null;
    const isVendorLogin = loginDetails.get('isVendor') ? loginDetails.get('isVendor') : null;

    const userId = loginDetails.get('User_name_while_login') ? loginDetails.get('User_name_while_login') : null;

    console.log('userId', userId)
    this.user_name = userId;

    this.isVendor = isVendorLogin == '1' ? true : false;
        

    this.officeCode = officeCode;
    
    if(this.user_name === 'DMICADA' || this.user_name === 'ADVISOR'){
      this.userId=encodeURIComponent(this.cryptoJs.Encrypt('DMICADA'))
    }
    else if(this.user_name === 'ADMIN'){
      this.userId=encodeURIComponent(this.cryptoJs.Encrypt('ADMIN'))
    }
    else if(this.user_name === 'CAO'){
      this.userId=encodeURIComponent(this.cryptoJs.Encrypt('CAO'))
    }
    
    else  if(this.isVendor){
        this.user_name=this.officeCode;
        this.userId=encodeURIComponent(this.cryptoJs.Encrypt(JSON.stringify(this.user_name)))
      }
      
    else{
      this.userId=encodeURIComponent(this.cryptoJs.Encrypt(this.user_name))
    }
  }

  getAppVerification_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
   return this.http.get<any>(`${environment.apiUrl}Reports/GetAppVerification_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }

  getAppVerification_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetAppVerification_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getAppVerification_UserWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetAppVerification_UserWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getAppVerification_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetAppVerification_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getEstimation_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetEstimation_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getEstimation_UserWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetEstimation_UserWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getEstimation_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetEstimation_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getEstimation_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetEstimation_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }

  getBoq_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetBOQ_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getBoq_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetBOQ_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getBoq_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetBOQ_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getBoq_MiType_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetBOQ_MIType_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getEstimationVerification_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetEstimateVerification_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getGrievenceHandler() {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}MICADAgrievance/GetAllGrievanceTickets`);
  }

  // updateGrievence(){
  //   this.parameter_api()
  //   return this.http.get<any>(`${environment.apiUrl}MICADAgrievance/GetAllGrievanceTickets`);
  // }

  updateGrievence(data:any):Observable<any>{
    this.parameter_api()
    return this.http.post(environment.apiUrl+'MICADAgrievance/UpdateGrievance',data);
  }
  getEstimationVerification_UserWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetEstimateVerification_UserWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getEstimationVerification_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetEstimateVerification_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getEstimationVerification_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetEstimateVerification_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getChallan_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetChallan_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }

  getChallan_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetChallan_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getPhysicalVerification_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPhysicalVerification_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getPhysicalVerification_UserWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPhysicalVerification_UserWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getPhysicalVerification_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPhysicalVerification_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getPhysicalVerification_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPhysicalVerification_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getFSV_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetFSV_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getFSV_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetFSV_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }

  getFSV_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetFSV_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getSTV_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetSTV_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getSTV_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetSTV_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getSTV_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetSTV_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getSTF_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetSTF_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getSTF_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetSTF_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getSTF_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetSTF_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getRTF_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetRTF_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getRTF_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetRTF_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getRTF_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetRTF_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getMiVerificationSubsidy_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetMiVerificationSubsidy_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getVendorMIArea_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetVendorMIArea_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getTankAbstract_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetTankAbstract_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getStage1_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetStage1_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getStage2_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetStage2_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getStage3_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetStage3_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getStage1_Subsidy_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetStage1_Subsidy_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getStage2_Subsidy_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetStage2_Subsidy_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getStage3_Subsidy_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetStage3_Subsidy_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getCanalAndTubewell_BasedReport(selectedYear:any) {
    return this.http.get<any>(`${environment.apiUrl}Reports/CanalAndTubewellBasedReport?financialyear=${selectedYear}`);
  }
  getChallan_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetChallan_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getChallan_Reconciliation_day_Report(selectedYear) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetChallan_Reconciliation_Day_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }  
  getCompletedApplication_DrillDown_Report(actionType,userId,status,filterType,MIType,value,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetCompletedApplication_DrillDown_Report?ActionType=${actionType}&Status=${status}&userId=${userId}&FilterType=${filterType}&MIType=${MIType}&Value=${value}&financialyear=${selectedYear}`);
  }
  getCompletedApplication_Block_DrillDown_Report(actionType,userId,status,filterType,MIType,value,block,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetCompletedApplication_Block_DrillDownReport?ActionType=${actionType}&Status=${status}&userId=${userId}&FilterType=${filterType}&MIType=${MIType}&Value=${value}&Block=${block}&financialyear=${selectedYear}`);
  }

  getTotalApplication_DrillDown_Report(actionType,userId,filterType,value,MIType,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetTotalApplication_DrillDown_Report?ActionType=${actionType}&userId=${userId}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&financialyear=${selectedYear}`);
  }
  getTotalApplication_Block_DrillDown_Report(actionType,userId,filterType,value,MIType,block,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetTotalApplication_Block_DrillDownReport?ActionType=${actionType}&userId=${userId}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&Block=${block}&financialyear=${selectedYear}`);
  }
  getPendingApplication_DrillDown_Report(actionType,userId,duration,filterType,value,MIType,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPendingApplication_DrillDown_Report?ActionType=${actionType}&userId=${userId}&Duration=${duration}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&financialyear=${selectedYear}`);
  }
  getPendingApplication_Block_DrillDown_Report(actionType,userId,duration,filterType,value,MIType,block,selectedYear){
    
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPendingApplication_Block_DrillDownReport?ActionType=${actionType}&userId=${userId}&Duration=${duration}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&Block=${block}&financialyear=${selectedYear}`);
  }
  getRejectedApplication_DrillDown_Report(actionType,userId,filterType,MIType,value,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetRejectedApplication_DrillDown_Report?ActionType=${actionType}&userId=${userId}&FilterType=${filterType}&MIType=${MIType}&Value=${value}&financialyear=${selectedYear}`);
  }
  getRejectedApplication_Block_DrillDown_Report(actionType,userId,filterType,MIType,value,block,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetRejectedApplication_Block_DrillDownReport?ActionType=${actionType}&userId=${userId}&FilterType=${filterType}&MIType=${MIType}&Value=${value}&Block=${block}&financialyear=${selectedYear}`);
  }

  get7500Report(selectedYear) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/Get7500Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }  

  getAtalReport(selectedYear) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetAtalReport?UserID=${this.userId}&financialyear=${selectedYear}`);
  }  
  getPendingApplication_lot_DrillDown_Report(actionType,userId,duration,filterType,value,MIType,Block,selectedYear){
    
    return this.http.get<any>(`${environment.apiUrl}Reports/getPendingApplication_Lot_DrillDown?ActionType=${actionType}&userId=${userId}&Duration=${duration}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&Block=${Block}&financialyear=${selectedYear}`);
  }
  getTotalApplication_lot_DrillDown_Report(actionType,userId,filterType,value,MIType,Block,selectedYear){
    
    return this.http.get<any>(`${environment.apiUrl}Reports/getTotalApplication_Lot_DrillDown?ActionType=${actionType}&userId=${userId}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&Block=${Block}&financialyear=${selectedYear}`);
  }
  getChallanCompletedApplication_DrillDown_Report(actionType,userId,status,filterType,value,MIType,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetChallanCompletedApplication_DrillDown_Report?ActionType=${actionType}&Status=${status}&userId=${userId}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&financialyear=${selectedYear}`);
  }
  getChallanReconsillationrptDrilldown(reqBody: any){
    return this.http.post<any>(`${environment.apiUrl}Reports/GetChallanReconsillationrptDrilldown`, reqBody);
  }
  getPondAbstract_DrillDown_Report(userId,district,status,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/getPondAbstract_DrillDown?userId=${userId}&District=${district}&Status=${status}&financialyear=${selectedYear}`);
  }
  getPondPending_DrillDown_Report(actionType,userId,district,program,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/getPondPending_DrillDown?ActionType=${actionType}&userId=${userId}&District=${district}&program=${program}&financialyear=${selectedYear}`);
  }
  getPreEstimation_DistrictWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPreEstimationSurvey_DistrictWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getPreEstimation_UserWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPreEstimationSurvey_UserWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getPreEstimation_VendorWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPreEstimationSurvey_VendorWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getPreEstimation_MonthWise_Report(selectedYear:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPreEstimationSurvey_MonthWise_Report?UserID=${this.userId}&financialyear=${selectedYear}`);
  }
  getAppVerificationTotalApplication_DrillDown_Report(actionType,userId,filterType,value,MIType,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetAppVerificationTotalApplication_DrillDown_Report?ActionType=${actionType}&userId=${userId}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&financialyear=${selectedYear}`);
  }
  getAppVerificationRejectedApplication_DrillDown_Report(actionType,userId,filterType,MIType,value,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetRejectedApplication_DrillDown_Report?ActionType=${actionType}&userId=${userId}&FilterType=${filterType}&MIType=${MIType}&Value=${value}&financialyear=${selectedYear}`);
  }
  getAppVerificationPendingApplication_DrillDown_Report(actionType,userId,duration,filterType,value,MIType,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetAppVerificationPendingApplication_DrillDown_Report?ActionType=${actionType}&userId=${userId}&Duration=${duration}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&financialyear=${selectedYear}`);
  }
  getAppVerificationCompletedApplication_DrillDown_Report(actionType,userId,status,filterType,MIType,value,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetAppVerificationCompletedApplication_DrillDown_Report?ActionType=${actionType}&Status=${status}&userId=${userId}&FilterType=${filterType}&MIType=${MIType}&Value=${value}&financialyear=${selectedYear}`);
  }
  getDDAssociateDailyTaskMI(userId,startDate,endDate){
    
    return this.http.get<any>(`${environment.apiUrl}Reports/DDAssociateDailyTaskMI?Userid=${userId}&startdate=${startDate}&endDate=${endDate}`);
  } 
  getDDAssociateDailyTaskPond(userId,startDate,endDate){
    
    return this.http.get<any>(`${environment.apiUrl}Reports/DDAssociateDailyTaskPond?Userid=${userId}&startdate=${startDate}&endDate=${endDate}`);
  }
  getPondCompleted_DrillDown_Report(actionType,userId,district,program,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/getPondCompleted_DrillDown?ActionType=${actionType}&userId=${userId}&District=${district}&program=${program}&financialyear=${selectedYear}`);
  }
  getVendor_MI_Area_Report(userId,status,MIType,value,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetVendorMIAreaReport_DrillDown?userId=${userId}&status=${status}&vendorCode=${value}&Component=${MIType}&financialyear=${selectedYear}`);
  }
  getChallanTotalApplication_DrillDown_Report(actionType,userId,status,filterType,value,MIType,selectedYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetChallanTotalApplication_DrillDown_Report?ActionType=${actionType}&userId=${userId}&FilterType=${filterType}&Value=${value}&MIType=${MIType}&financialyear=${selectedYear}`);
  }
  // getConsolidated_Report(reqBody:any):any {
  //   return this.http.post(`${environment.apiUrl}Reports/getmiconsolidatedreport`, reqBody);
  // }
  // getPondConsolidated_Report(financialYear){
  //   return this.http.get<any>(`${environment.apiUrl}Reports/getpondconsolidatedreport?financialyear=${financialYear}`);
  // }
  getPondConsolidated_Report(reqBody:any):any {
    return this.http.post(`${environment.apiUrl}Reports/getpondconsolidatedreport`, reqBody);
  }
  getConsolidated_Report(reqBody:any):any {
    return this.http.post(`${environment.apiUrl}Reports/getmiconsolidatedreport`, reqBody);
  }
  getMIConsolidatedReportVendorWise(reqBody:any):any {
    return this.http.post(`${environment.apiUrl}Reports/getMIConsolidatedReportVendorWise?VendorCode=''`, reqBody);
  }
  getFinanacialYearList(){
    return this.http.get<any>(`${environment.apiUrl}Reports/getfinancialyearlist`);
  }
  getInventoryReport(){
    return this.http.get<any>(`${environment.apiUrl}Department/GetInventoryReport`);
  }
  // getPendingDetailUser_DrillDown_Report(ActionType, District, FinYear, RequestType){
  //   return this.http.get<any>(`${environment.apiUrl}Reports/GetPendingDetailUser?ActionType=${ActionType}&District=${District}&FinYear=${FinYear}&RequestType=${RequestType}`);
  // }
  getPendingDetailUser_DrillDown_Report(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Reports/GetPendingDetailUser?ActionType=${reqBody?.ActionType}&District=${reqBody?.District}&FinYear=${reqBody?.FinYear}&RequestType=${reqBody?.RequestType}&GeoType=${reqBody?.GeoType}&GeoCode=${reqBody?.GeoCode}&Caste=${reqBody?.Caste}&CropId=${reqBody?.CropId}&userType=${reqBody?.userType}`, {});
  }
  getPendingDetailUserWise_DrillDown_Report(ActionType, District, FinYear, UserId, RequestType){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPendingUserWiseDrillDown?ActionType=${ActionType}&District=${District}&FinYear=${FinYear}&UserId=${UserId}&RequestType=${RequestType}`);
  }
  getDrillDownSubsidyDetail(reqBody:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Department/GetDrillDownSubsidyDetail?Dist_Code=${reqBody?.Dist_Code}&Block_Code=${reqBody?.Block_Code}&Vill_Code=${reqBody?.Vill_Code}`);
  }
  getDistrictMaster() {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Department/GetDistrictMaster`);
  }
  getBlockMaster(distCode: any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Department/GetBlockMaster?Dist_Code=${distCode}`);
  }
  getConsolidatedLotRpt(LotType: string) {
    return this.http.get<any>(`${environment.apiUrl}Reports/GetConsolidatedLotRpt?LotType=${LotType}`);
  }

  // getConsolidatedAggReport(financialYear){
  //   // if(window.sessionStorage.getItem("AggReport1Data") && financialYear == ''){
  //   //   return of(JSON.parse(window.sessionStorage.getItem("AggReport1Data")));
  //   // }else{
  //   //   return this.http.get<any>(`${environment.apiUrl}Reports/GetConsolidatedAggReport?FinYear=${financialYear}`);
  //   // }
  //   return this.http.post<any>(`${environment.apiUrl}Reports/GetConsolidatedAggReport`, req);
  // }

  getConsolidatedAggReport(reqBody:any):any {
    return this.http.post(`${environment.apiUrl}Reports/getmiconsolidatedreport`, reqBody);
  }

  miCanalTubewellApplicationFromTBL(){
    return this.http.get<any>(`${environment.apiUrl}Reports/MICanalTubewellApplicationFromTBL`);
  }

  pondCanalTubewellApplicationFromTBL(){
    return this.http.get<any>(`${environment.apiUrl}Reports/PondCanalTubewellApplicationFromTBL`);
  }

  getChallanReportByVendorId(id:any) {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetChallanReportByVendorId?VendorId=${id}`);
  }
  getLotReport() {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/GetLotReport`);
  }
  getLotConsolidatedReport() {
    this.parameter_api()
    return this.http.get<any>(`${environment.apiUrl}Reports/ConsolidatedReportLotCAO`);
  }

  getConsolidatedAggReportNew2(financialYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetConsolidatedAggReportNew2?FinancialYear=${financialYear}`);
  }

  getMIAggregateTabsDataNew(financialYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetMIAggregateTabsDataNew?financialYear=${financialYear}`);
  }
  
  miYearWiseTotalAppCount(){
    return this.http.get<any>(`${environment.apiUrl}Reports/MIYearWiseTotalAppCount`);
  }

  pondYearWiseTotalAppCount(){
    return this.http.get<any>(`${environment.apiUrl}Reports/PondYearWiseTotalAppCount`);
  }

  getDataForDashboardGraphs(districtCode, FinYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetDataForDashboardGraphs?DistrictCode=${districtCode}&FinYear=${FinYear}`);
  }

  getMISchemeWiseAppCount(districtCode, FinYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetMISchemeWiseAppCount?FinYear=${FinYear}&DistCode=${districtCode}`);
  }

  getPondSchemeWiseAppCount(districtCode, FinYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPondSchemeWiseAppCount?FinYear=${FinYear}&DistCode=${districtCode}`);
  }

  getDataForDashboardGraphsVendor(districtCode,userType,vendorCode, FinYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetDataForDashboardGraphsVendorWise?DistrictCode=${districtCode}&vendorCode=${vendorCode}&FinYear=${FinYear}`);
  }

  getDataForDashboardGraphsPond(districtCode, finYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetDataForDashboardGraphsPond?DistrictCode=${districtCode}&FinYear=${finYear}`);
  }

  getDistrictWiseAllCountDashboard(districtCode, finYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetDistrictWiseAllCountDashboard?DistrictCode=${districtCode}&FinYear=${finYear}`);
  }
  GetEPCReports(){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetEPCReports?DistrictCode`);
  }
  getEpcFullData(){
    return this.http.get<any>(`${environment.apiUrl}Vendor/GetEPCDetails`, { headers: this.buildHeaders() })
  }
  // getDistrictWiseAllCountDashboard(districtCode, vendorCode, finYear, type){
  //   return this.http.get<any>(`${environment.apiUrl}Reports/GetDistrictWiseAllCountDashboardVendorWise?DistrictCode=${districtCode}&VendorCode=${vendorCode}&FinYear=${finYear}&Type=${type}`);
  // }

  getDistrictWiseAllCountDashboardVendor(districtCode, userType, vendorCode, finYear){
    return this.http.post<any>(`${environment.apiUrl}Reports/GetDistrictWiseAllCountDashboardVendorWise?DistrictCode=${districtCode}&VendorCode=${vendorCode}&FinYear=${finYear}&Type=${userType}`, {});
  }

  // GetDistrictWiseAllCountDashboardVendorWise(districtCode,userType,vendorCode){ 
  //   if(userType!=='Vendor'){
  //     return this.http.get<any>(`${environment.apiUrl}Reports/GetDistrictWiseAllCountDashboard?DistrictCode=${districtCode}`);
  //   }
  //   else{
  //     return this.http.get<any>(`${environment.apiUrl}Reports/GetDistrictWiseAllCountDashboardVendorWise?DistrictCode=${districtCode}&vendorCode=${vendorCode}`);
  //   }
    
  // }

  getDistrictWiseAllCountDashboardPond(districtCode, finYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetDistrictWiseAllCountDashboardPond?DistrictCode=${districtCode}&FinYear=${finYear}`);
  }

  getSubsidyDisbursedAgg(financialYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetSubsidyDisbursedAgg?FinancialYear=${financialYear}`);
  }

  aggDataDistrictWiseForGraph(financialYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/AggDataDistrictWiseForGraph?FinancialYear=${financialYear}`);
  }

  getConsolidatedAggReportNew2DrillDown(financialYear, actiontype, count){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetConsolidatedAggReportNew2DrillDown?FinYear=${financialYear}&ActionType=${actiontype}&Count=${count}`);
  }

  getMIAggTabsUnProcessedAppsCountNew(financialYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetMIAggTabsUnProcessedAppsCountNew?FinYear=${financialYear}`);
  }

  getMIAggTabsUnProcessedAppsCountNewVendor(vendorCode, financialYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetMIAggTabsUnProcessedAppsVendorWiseCountNew?FinYear=${financialYear}&vendorCode=${vendorCode}`);
  }

  getPondAggTabsUnProcessedAppsCountNew(financialYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPondAggTabsUnProcessedAppsCountNew?FinYear=${financialYear}`);
  }

  getMIAggTabsUnProcessedAppsDrillDownNew(financialYear, actionId){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetMIAggTabsUnProcessedAppsDrillDownNew?FinYear=${financialYear}&Action=${actionId}`);
  }

  getPondAggTabsUnProcessedAppsDrillDownNew(financialYear, actionId){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPondAggTabsUnProcessedAppsDrillDownNew?FinYear=${financialYear}&Action=${actionId}`);
  }

  // getMIBeneficiaryReport(financialYear){
  //   return this.http.get<any>(`${environment.apiUrl}Reports/GetMIBeneficiaryReport?FinYear=${financialYear}`);
  // }

  // getPondBeneficiaryReport(financialYear){
  //   return this.http.get<any>(`${environment.apiUrl}Reports/GetPondBeneficiaryReport?FinYear=${financialYear}`);
  // }

  getPondAggregateTabsDataNew(financialYear){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPondAggregateTabsDataNew?financialYear=${financialYear}`);
  }

  // getPondConsolidatedAggReportDrillDown(financialYear, actiontype, count){
  //   return this.http.get<any>(`${environment.apiUrl}Reports/GetPondAggDrillDownReport?FinYear=${financialYear}&ActionType=${actiontype}&Count=${count}`);
  // }

  getMIBeneficiaryReport(userId){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetMIBeneficiaryReport?UserId=${userId}`);
  }

  getPondBeneficiaryReport(){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPondBeneficiaryReport`);
  }

  getConsituencyMaster(){
    return this.http.get<any>(`${environment.apiUrl}Department/GetConsituencyMaster`);
  }

  getVillageMaster(distCode, blockCode){
    return this.http.get<any>(`${environment.apiUrl}Department/GetVillageMaster?Dist_Code=${distCode}&Block_Code=${blockCode}`);
  }

  getVillageMasterByConsituency(blockCode, conCode){
    return this.http.get<any>(`${environment.apiUrl}Department/GetVillageMasterByConsituency?Block_Code=${blockCode}&ConsituencyCode=${conCode}`);
  }
  getMIAggregateTabsDataNewVendor(financialYear,userType,vendorCode){
    if(userType!=='Vendor'){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetMIAggregateTabsDataNew?financialYear=${financialYear}`);
    }
    else{
      return this.http.get<any>(`${environment.apiUrl}Reports/GetMIAggregateTabsDataNewVendorWise?financialYear=${financialYear}&vendorCode=${vendorCode}`);
    }
  }
  getMIAggTabsUnProcessedAppsDrillDownNewVendor(financialYear, actionId,vendorCode, userType, autoId){
    if(userType!='Vendor'){
      return this.http.get<any>(`${environment.apiUrl}Reports/GetMIAggTabsUnProcessedAppsDrillDownNew?FinYear=${financialYear}&Action=${actionId}&AutoId=${autoId}`);
    }
    else{
      return this.http.get<any>(`${environment.apiUrl}Reports/GetMIAggTabsUnProcessedAppsDrillDownVendorWiseNew?FinYear=${financialYear}&Action=${actionId}&vendorCode=${vendorCode}&AutoId=${autoId}`);
    }
    
  }

  getPondAggTabsUnProcessedAppsDrillDownNewVendor(financialYear, actionId,vendorCode:any,userType:any){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPondAggTabsUnProcessedAppsDrillDownNew?FinYear=${financialYear}&Action=${actionId}`);
  }

  getMIAppLevelWiseReport(financialYear, autoId, vendorName){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetMIAppLevelWiseReport?FinYear=${financialYear}&AutoId=${autoId}&VendorName=${vendorName}`);
  }

  getPondAppLevelWiseReport(financialYear, autoId){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPondAppLevelWiseReport?FinYear=${financialYear}&AutoId=${autoId}`);
  }

  getSubsidyDistribution(type:any){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetSubsidyDistribution?FormatType=${type}`);
  }

  getDistinctLotNoByFinYear(finYear, lotType){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetDistinctLotNoByFinYear?Fin_Year=${finYear}&LotType=${lotType}`);
  }

  getPaymentsByLotNo(lotNo){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetPaymentsByLotNo?Lot_No=${lotNo}`);
  }

  getUnderProcessDistrictWise(finYear){
    return this.http.get<any>(`${environment.apiUrl}Reports//GetUnderProcessDistrictWise?FinYear=${finYear}`);
  }

  getLotDataInCAOFinDashboard(apiName, lotNo, status, userType){
    return this.http.get<any>(`${environment.apiUrl}Department/${apiName}?LotNo=${lotNo}&Status=${status}&UserType=${userType}`);
  }

  getTankLotDataInCAOFinDashboard(tankStage, lotNo, status, userType){
    return this.http.get<any>(`${environment.apiUrl}Department/GetApplicationsForPondFarmerShareToVendorPFMSExport?LotNo=${lotNo}&Stage=${tankStage}&Status=${status}&UserType=${userType}`);
  }
  getSubsidyData(formatType: string): any {
    return this.http.get<any>(`${environment.apiUrl}Reports/GetSubsidyDistribution`, {
      params: { FormatType: formatType }
    });
  }

  getDistrictMasterOther(isAtal){
    return this.http.get<any>(`${environment.apiUrl}Department/GetDistrictMasterOther?IsAtal=${isAtal}`);
  }

  getBlockMasterOther(districtCode, isAtal){
    return this.http.get<any>(`${environment.apiUrl}Department/GetBlockMasterOther?Dist_Code=${districtCode}&IsAtal=${isAtal}`);
  }

  getVillageMasterOther(districtCode, blockCode, isAtal){
    return this.http.get<any>(`${environment.apiUrl}Department/GetVillageMasterOther?Dist_Code=${districtCode}&Block_Code=${blockCode}&IsAtal=${isAtal}`);
  }
  
  getSubsidyDistributionDrillDown(reqBody){
    return this.http.post<any>(`${environment.apiUrl}Reports/GetSubsidyDistributionDrillDown`, reqBody);
  }

  getUserType(userId){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetUserTypeList?UserId=${userId}`);
  }

  getUserList(userRole, actionId){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetUserList?ActionID=${actionId}&UserRole=${userRole}`);
  }

  // getUserListForReports(actionId, userId, userType){
  //   return this.http.get<any>(`${environment.apiUrl}Reports/GetUserListForReports?ActionId=${actionId}&UserId=${userId}&UserType=${userType}`);
  // }

  getUserActions(userType){
    return this.http.get<any>(`${environment.apiUrl}Reports/GetUserActions?UserType=${userType}`);
  }
}
